import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VersionsInfoModalComponent } from '../versions-info-modal/versions-info-modal.component';
import { take } from 'rxjs/operators';
import { AppsService } from 'app/service/apps/apps.service';
import { GlobalService } from 'app/service/global/global.service';

@Component({
  selector: 'aca-versions-info',
  templateUrl: './versions-info.component.html',
  styleUrls: ['./versions-info.component.scss']
})
export class VersionsInfoComponent implements OnInit {
  constructor(public dialog: MatDialog, private appService: AppsService, private globalService: GlobalService) {}

  ngOnInit(): void {}

  onOpenModalVersions() {
    this.appService
      .getAppVersionByAppUrl(window.location.origin + '/')
      .pipe(take(1))
      .subscribe((data) => {
        if (!data.result || data.result.length == 0) {
          return this.globalService.openSnackBar('A aplicação não possui versões cadastradas', 'caution');
        }

        const dialogRef = this.dialog.open(VersionsInfoModalComponent, {
          width: '70vw',
          height: '700px',
          disableClose: true,
          data: data.result
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
          console.log(result);
        });
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/versions/versions-info/versions-info.component.ts